module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/logo_leaders03-66cc835524def9369929dcda727ceac0.svg";